import { dataCnyWallet } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCnyWallet = /*#__PURE__*/createIcon(dataCnyWallet)
export default IconCnyWallet
